import React, { useRef, useContext, useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import BoardContext from '../Board/context';
import { MdAdd, MdClose } from 'react-icons/md';
import Card from '../Card';
import { Container, InputTel, ModalConfirm, ScrollList, ViewInput } from './styles';
import { Input } from 'antd';
import { toast } from 'react-toastify';
import api from '../../services/api';
import IntlCurrencyInput from "react-intl-currency-input";

const { TextArea } = Input;

export default function List({ data, lists, userId, index: listIndex, disabled }) {

  const ref = useRef();
  const { move, edit } = useContext(BoardContext);
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone_number, setPhone_number] = useState("")
  const [observation, setObservation] = useState("")
  const [employees, setEmployees] = useState("")
  const [necessity, setNecessity] = useState("")
  const [cnpj, setCnpj] = useState("")
  const [location, setLocation] = useState("")
  const [isOpen, setIsOpen] = useState(false)

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const [{ isDragging }, dragRef] = useDrag({
    item: { type: 'CARD', listIndex },
    canDrag: false,
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, dropRef] = useDrop({
    accept: 'CARD',
    drop(item, monitor) {
      const draggedListIndex = item.listIndex;
      const targetListIndex = listIndex;

      const draggedIndex = item.index;
      const targetIndex = listIndex;

      if (draggedListIndex === targetListIndex) {
        return;
      }
      
      let leads = lists[draggedListIndex].leads

      if(disabled){
        toast.error("Enviar proposta durante qualificação")
        return;
      }

      move(draggedListIndex, targetListIndex, leads[draggedIndex].id);

      item.index = targetIndex;
      item.listIndex = targetListIndex;
    }
  })


  dragRef(dropRef(ref));

  function IsEmail(field) {
    const regx = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i
    return regx.test(field)
  }

  function IsPhone(field) {
    if (field.length >= 10) {
      return true
    } else {
      return false
    }
  }

  async function createLead() {
    if (!name) {
      toast.warn('Preencha o nome para realizar o cadastro');
    } else {
      if (email) {
        if (!IsEmail(email)) {
          toast.warn("Email inserido é inválido")
          return
        }
      }
      if (phone_number) {
        if (!IsPhone(phone_number)) {
          toast.warn("Telefone inserido é inválido")
          return
        }
      }
      await api.post(`/lead`, {
        name: name,
        email: email,
        observation: observation,
        phone_number: phone_number,
        employees: employees,
        necessity: necessity,
        cnpj: cnpj,
        location: location,
      }).then((response) => {
        toast.success("Lead criado com sucesso")
        setIsOpen(false)
        let listC = lists
        listC[0].leads.push({ ...response.data, historical: [] })
        edit(listC)
      }).catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message)
            } else {
              toast.error("Erro Interno. verifique sua conexão e tente novamente")
            }
          } else {
            toast.error("Erro Interno. verifique sua conexão e tente novamente")
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente")
        }
      })
    }
  }

  return (
    <Container ref={ref}>
      <header>
        <h2>{data.name} ({data.leads.length})</h2>
        {(listIndex == 0 && !userId )? (
          <button type="button" onClick={() => {
            setName("")
            setEmail("")
            setObservation("")
            setEmployees("")
            setCnpj("")
            setNecessity("")
            setLocation("")
            setPhone_number("")
            setIsOpen(true)
          }}>
            <MdAdd size={24} color="#FFF" />
          </button>
        ) : (
          <h2>{listIndex > 3 && data.leads.reduce((soma, item) => soma + item.value, 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</h2>
        )}
      </header>

      <ScrollList>
        <ul>
        {data.leads.map((card, index) => (
          <Card
            key={card.id}
            listIndex={listIndex}
            index={index}
            data={card}
            userId={userId}
            lists={lists}
            grid={data}
          />
        ))}
        </ul>
      </ScrollList>
      <ModalConfirm open={isOpen}>
        <div className="content">
          <div className="content-header">
            <p>Criando um novo lead</p>
            <button type="button" className="close-button">
              <MdClose
                size={20}
                color="#3a3a3a"
                onClick={() => setIsOpen(false)}
              />
            </button>
          </div>
          <ViewInput>
            <p>Nome*</p>
            <Input
              placeholder="nome"
              value={name}
              onChange={(event) => setName(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>Email*</p>
            <Input
              placeholder="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>Telefone*</p>
            <InputTel mask="(99) 99999-9999" maskChar="" noSpaceBetweenChars={true} value={phone_number} placeholder={"telefone"} style={{

            }}
              onChange={(text) => { setPhone_number(text.target.value.replace(/[^0-9]/g, '')) }} />

          </ViewInput>
          <ViewInput>
            <p>Necessidade</p>
            <Input
              placeholder="necessidade"
              value={necessity}
              onChange={(event) => setNecessity(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>Funcionários</p>
            <Input
              placeholder="funcionários"
              value={employees}
              onChange={(event) => setEmployees(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>CNPJ</p>
            <Input
              placeholder="cnpj"
              value={cnpj}
              onChange={(event) => setCnpj(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>Localização</p>
            <Input
              placeholder="localização"
              value={location}
              onChange={(event) => setLocation(event.target.value)} />
          </ViewInput>
          <ViewInput>
            <p>Observação</p>
            <TextArea
              style={{ minHeight: 60 }}
              placeholder="observação"
              value={observation}
              onChange={(event) => setObservation(event.target.value)} />
          </ViewInput>
          <footer className="content-footer">
            <span onClick={() => setIsOpen(false)}>Cancelar</span>
            <button style={{ background: "#f2760a", cursor: "pointer" }} onClick={async () => {
              createLead()
            }}>
              Criar
            </button>

          </footer>
        </div>
      </ModalConfirm>
    </Container >
  );
}
